import React from 'react';

export function Skel({ className = '' }) {
  return <span className={`skel ${className}`.trim()} />;
}

export function TableSkeleton({ columns = 5, rows = 8 }) {
  return (
    <div className="table-card panel" aria-hidden="true">
      <div className="table-toolbar">
        <Skel className="skel--search" />
        <Skel className="skel--chip" />
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              {Array.from({ length: columns }, (_, index) => (
                <th key={index}>
                  <Skel className="skel--th" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }, (_, row) => (
              <tr key={row}>
                {Array.from({ length: columns }, (_, col) => (
                  <td key={col}>
                    <Skel className={col === 1 ? 'skel--wide' : 'skel--cell'} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="table-footer">
        <Skel className="skel--meta" />
        <Skel className="skel--pager" />
      </div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <section aria-hidden="true">
      <div className="cards">
        {Array.from({ length: 5 }, (_, index) => (
          <div className="card card--skel" key={index}>
            <Skel className="skel--label" />
            <Skel className="skel--value" />
          </div>
        ))}
      </div>
      <div className="panel action-row">
        <div>
          <Skel className="skel--title" />
          <Skel className="skel--line" />
        </div>
        <Skel className="skel--btn" />
      </div>
    </section>
  );
}

export function SettingsSkeleton() {
  return (
    <section aria-hidden="true">
      <div className="settings panel">
        <div className="settings-grid">
          {Array.from({ length: 8 }, (_, index) => (
            <div className="field" key={index}>
              <Skel className="skel--label" />
              <Skel className="skel--input" />
            </div>
          ))}
        </div>
        <Skel className="skel--title" />
        <Skel className="skel--line" />
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                {Array.from({ length: 4 }, (_, index) => (
                  <th key={index}>
                    <Skel className="skel--th" />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 6 }, (_, row) => (
                <tr key={row}>
                  {Array.from({ length: 4 }, (_, col) => (
                    <td key={col}>
                      <Skel className="skel--input" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
